module.exports = __webpack_public_path__ + "static/media/white-rose.57cb22d7.png";